export default {
  path: '/gold-trend-subscribe',
  name: 'gold-trend-subscribe',
  meta: {
    title: '黄金趋势订阅',
    pageId: 'D9374'
  },
  component: () =>
    import(/* webpackChunkName: "gold-trend-subscribe" */ 'app/trend-subscribe/index.vue')
}